export interface PathValue {
    value: string;
}

export const Paths: { [key: string]: PathValue } = {
    Login: {
        value: '/auth/login'
    },
    Register: {
        value: '/auth/register'
    },
    ResetPasswordRequest: {
        value: '/auth/reset-password-request'
    },
    ResetPassword: {
        value: '/auth/reset-password'
    },
    ActivateUser: {
        value: "/auth/activate-user"
    },
    Home: {
        value: "/"
    },
    LogoFull: {
        value: "images/logo-white.png"
    },
    Logo: {
        value: "images/logo-white.png"
    },
    LogoBlack: {
        value: "images/logo-black.png"
    },
    EmailActivated: {
        value: "images/welcome-banner.png"
    },
    Icon: {
        value: "images/icon.png"
    },
    Stakeholders: {
        value: "/stakeholders"
    },
    Imports: {
        value: "/imports/all"
    },
    ImportsNoISO: {
        value: "/imports/no-iso"
    },
    ImportsNoBrand: {
        value: "/imports/no-brand"
    },
    Operative: {
        value: "/operative/main"
    },
    OperativeNoMail: {
        value: "/operative/no-mail"
    },
    OperativeListMailToSend: {
        value: "/operative/mailtosend"
    },
    OperativeListUnreadEmails: {
        value: "/operative/unreadmail"
    },
    OperativeListToBeCalled: {
        value: "/operative/tobecalled"
    },
    Mail: {
        value: "/mail/:FolderId"
    },
    MailDetail: {
        value: "/mail/detail/:id"
    },
    MailNew: {
        value: "/mail/new"
    },
    SettingsRoles: {
        value: "/settings/roles"
    }
};
